<template>
  <base-modal form title="Capture Offline Payment" body-class="is-paddingless">
    <loader v-if="loading"/>
    <template v-else>
      <notification class="is-info is-radiusless is-marginless">
        Please supply the <u>date</u> and <u>amount</u> of the offline payment.
      </notification>
      <div class="grid gap-1 p-2">

        <date-picker
          no-time
          class="is-marginless"
          v-model="booking.payment_received"
          :error="errors.payment_received"
          error-class="has-text-danger">
          <static-button slot="left">Payment Date</static-button>
        </date-picker>

        <div class="grid has-2-columns gap-1">
          <formatted-text-input
            class="is-marginless"
            classes="has-text-weight-bold"
            :options="{
              numeral: true,
              numeralPositiveOnly: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 5,
            }"
            v-model="booking.payment_amount"
            :error="errors.payment_amount"
            error-class="has-text-danger">
            <static-button slot="left">R</static-button>
          </formatted-text-input>

          <text-input readonly
            :label="false"
            :value="booking.display_total"
            class="pointer-events-none is-marginless"
            classes="is-white has-text-weight-light has-text-right">
            <action-button class="is-light has-text-weight-light" slot="left">Booking Total</action-button>
          </text-input>
        </div>

        <data-selector
          label-key="name"
          value-key="id"
          v-model="booking.payment_method_id"
          :items="paymentMethods"
          :label="false">
          <static-button slot="left">Paid using Method</static-button>
        </data-selector>

        <text-input readonly
          :label="false"
          :value="`${user.full_name} (${user.email})`"
          class="pointer-events-none is-marginless"
          classes="is-white has-text-weight-light">
          <action-button class="is-light has-text-weight-light" slot="left">Captured By</action-button>
        </text-input>
      </div>
    </template>

    <div slot="footer" class="buttons">
      <submit-button
        :disabled="loading"
        :working="working"
        @submit="save"
        left-icon="check"
        class="is-success is-rounded has-text-weight-bold">
        Capture Payment
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { captureOfflinePayment } from '@/api/booking'
import { mapState } from 'vuex'
import { listPaymentMethods } from '@/api/payment-method'

export default {

  props: {
    payload: Object
  },

  data:() => ({
    loading: true,
    working: false,
    booking: {},
    paymentMethods: [],
  }),

  computed: {
    ...mapState('auth', [
      'user'
    ])
  },

  created() {
    listPaymentMethods(response => {
      this.paymentMethods = response.data
      this.booking = { ...this.payload }
      this.loading = false
    }, this.$whoops)
  },

  methods: {
    save() {
      this.working = true
      captureOfflinePayment(this.booking, () => {
        this.$toast.success('Payment captured.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }
}
</script>
